// extracted by mini-css-extract-plugin
export default {"form":"AddProduct_form__jHXYf"};